export function annualLeave(intl, update_result, exceeded) {
    const exceededNumber = Number(exceeded).toFixed(1);
    const entitledIsNotEnough = intl.formatMessage({id: 'error.entitled_is_not_enough'});
    const applicationExpired = intl.formatMessage({id: 'new_application.expired'});

    let summary = [entitledIsNotEnough, ""];
    update_result.map(function (result, i) {
        const balance = Number(result.current_balance).toFixed(1);
        const taken = Number(result.restore).toFixed(1);
        summary.push(
            result.year + ' ' + intl.formatMessage({id: 'single_year_annual_balance'}) + ': ' +
            balance + ' (' + applicationExpired + ' ' + result.expiry_date + ')'
        )

        summary.push(
            intl.formatMessage({id: 'error.counted_to'}) + ' ' + result.year + ' ' +
            intl.formatMessage({id: 'error.allowance'}) + ': ' +
            taken,
        )
    });

    summary.push(
        intl.formatMessage({id: 'new_application.exceeded'}) + ': ' +
        exceededNumber,
    )

    return summary.join('\n');
}

export function sickLeave(intl, message, type = 'apply') {
    const { start_date, until_date, remaining_balance, requested_days, exceeded, update_result} = message;
    const exceededNumber = Number(exceeded).toFixed(1);
    const noEnoughRemainingBalance = intl.formatMessage({id: 'error.no_enough_remaining_balance'});
    const entitledIsNotEnough = intl.formatMessage({id: 'error.entitled_is_not_enough'});
    const applicationExpired = intl.formatMessage({id: 'new_application.expired'});

    let summary = type === 'apply' ? [entitledIsNotEnough, ""] : [noEnoughRemainingBalance, ""];

    if (type === 'apply') {
        update_result.map(function (result, i) {
            const balance = Number(result.current_balance).toFixed(1);
            const taken = Number(result.restore).toFixed(1);
            summary.push(
                result.year + ' ' + intl.formatMessage({id: 'single_year_annual_balance'}) + ': ' +
                balance + ' (' + applicationExpired + ' ' + result.expiry_date + ')'
            )

            summary.push(
                intl.formatMessage({id: 'error.counted_to'}) + ' ' + result.year + ' ' +
                intl.formatMessage({id: 'error.allowance'}) + ': ' +
                taken,
            )
        });
    }

    // summary.push(
    //     intl.formatMessage({id: 'new_application.exceeded'}) + ': ' +
    //     exceededNumber,
    // )

    return summary.join('\n');
}
